import { render, staticRenderFns } from "./ResultAI.vue?vue&type=template&id=4ed0c580&scoped=true&"
import script from "./ResultAI.vue?vue&type=script&lang=js&"
export * from "./ResultAI.vue?vue&type=script&lang=js&"
import style0 from "./ResultAI.vue?vue&type=style&index=0&id=4ed0c580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0c580",
  null
  
)

export default component.exports